import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  ASSESSMENT_OFFENCE,
  ASSESSMENT_OFFENCE_ALL,
  ASSESSMENT_OFFENCE_CHANGE_STATUS,
  ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS,
  ASSESSMENT_OFFENCE_CREATE,
  ASSESSMENT_OFFENCE_DELETE,
  ASSESSMENT_OFFENCE_INVIGILATION,
  ASSESSMENT_OFFENCE_INVIGILATION_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_CREATE,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_DELETE,
  ASSESSMENT_OFFENCE_INVIGILATION_CREATE,
  ASSESSMENT_OFFENCE_INVIGILATION_DELETE,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_CREATE,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_DELETE,
  ASSESSMENT_OFFENCE_PUBLISH,
  ASSESSMENT_OFFENCE_REPORT_ALL,
  ASSESSMENT_OFFENCE_REPORT_CREATE,
  ASSESSMENT_OFFENCE_REPORT_LIST,
  ASSESSMENT_OFFENCE_TYPE,
  ASSESSMENT_OFFENCE_TYPE_ALL,
  ASSESSMENT_OFFENCE_TYPE_CREATE,
  ASSESSMENT_OFFENCE_TYPE_DELETE,
  ASSESSMENT_OFFENCE_UNPUBLISH,
  REPORT_MISCONDUCT,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const assessmentOffence = createAsyncThunk(
  ASSESSMENT_OFFENCE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offence(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceCreate = createAsyncThunk(
  ASSESSMENT_OFFENCE_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceAll = createAsyncThunk(
  ASSESSMENT_OFFENCE_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceDelete = createAsyncThunk(
  ASSESSMENT_OFFENCE_DELETE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceDeleteById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilation = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceInvigilation(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationCreate = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceInvigilationCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationAll = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceInvigilationAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationDelete = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_DELETE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceInvigilationDeleteById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationConsultations = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS,
  async (
    params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.offenceInvigilationConsultations(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationConsultationsCreate = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_CREATE,
  async (
    params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.offenceInvigilationConsultationsCreate(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationConsultationsAll = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL,
  async (
    params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS_ALL}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.offenceInvigilationConsultationsAll(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationConsultationsDelete = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_DELETE,
  async (
    params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS}{id}`, 'delete'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.offenceInvigilationConsultationsDeleteById(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationMinutes = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_MINUTES}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceInvigilationMinutes(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationMinutesCreate = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_MINUTES}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceInvigilationMinutesCreate(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationMinutesAll = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL,
  async (
    params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_MINUTES_ALL}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.offenceInvigilationMinutesAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceInvigilationMinutesDelete = createAsyncThunk(
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_DELETE,
  async (
    params: PayloadCreatorParams<`/${typeof API.OFFENCE_INVIGILATION_MINUTES}{id}`, 'delete'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.offenceInvigilationMinutesDeleteById(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceType = createAsyncThunk(
  ASSESSMENT_OFFENCE_TYPE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_TYPE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceType(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceChangeStatus = createAsyncThunk(
  ASSESSMENT_OFFENCE_CHANGE_STATUS,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_CHANGE_STATUS}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceChangeStatus(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceTypeCreate = createAsyncThunk(
  ASSESSMENT_OFFENCE_TYPE_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_TYPE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceTypeCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceTypeAll = createAsyncThunk(
  ASSESSMENT_OFFENCE_TYPE_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_TYPE_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceTypeAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceTypeDelete = createAsyncThunk(
  ASSESSMENT_OFFENCE_TYPE_DELETE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_TYPE}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceTypeDeleteById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffencePublish = createAsyncThunk(
  ASSESSMENT_OFFENCE_PUBLISH,
  async (params: PayloadCreatorParams<`/${typeof API.ASSESSMENT_OFFENCE_PUBLISH}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.offencePublish(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceUnpublish = createAsyncThunk(
  ASSESSMENT_OFFENCE_UNPUBLISH,
  async (params: PayloadCreatorParams<`/${typeof API.ASSESSMENT_OFFENCE_UNPUBLISH}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceUnpublish(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceReportList = createAsyncThunk(
  ASSESSMENT_OFFENCE_REPORT_LIST,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_REPORT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceReportList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceReportCreate = createAsyncThunk(
  ASSESSMENT_OFFENCE_REPORT_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_REPORT}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceReportCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceReportAll = createAsyncThunk(
  ASSESSMENT_OFFENCE_REPORT_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.OFFENCE_REPORT_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.offenceReportAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceSubjectBoardStatusChange = createAsyncThunk(
  ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS,
  async (
    params: PayloadCreatorParams<`${typeof API.OFFENCE_CHANGE_SUBJECT_BOARD_STATUS}`, 'put'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.offenceChangeSubjectBoardStatus(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const reportMisconduct = createAsyncThunk(
  REPORT_MISCONDUCT,
  async (params: PayloadCreatorParams<`${typeof API.REPORT_MISCONDUCT}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.reportMisconduct(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const assessmentOffenceClear = createAction(`${ASSESSMENT_OFFENCE}/clear`)

export const assessmentOffenceAllClear = createAction(`${ASSESSMENT_OFFENCE_ALL}/clear`)

export const assessmentOffenceTypeAllClear = createAction(`${ASSESSMENT_OFFENCE_TYPE_ALL}/clear`)

export const assessmentOffenceInvigilationClear = createAction(`${ASSESSMENT_OFFENCE_INVIGILATION}/clear`)

export const assessmentOffenceInvigilationAllClear = createAction(`${ASSESSMENT_OFFENCE_INVIGILATION_ALL}/clear`)

export const assessmentOffenceInvigilationConsultationsAllClear = createAction(
  `${ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL}/clear`
)

export const assessmentOffenceInvigilationConsultationsClear = createAction(
  `${ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS}/clear`
)

export const assessmentOffenceInvigilationMinutesAllClear = createAction(
  `${ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL}/clear`
)
